"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearJdMallCache = clearJdMallCache;
exports.deleteJdPriceAdjustRecord = deleteJdPriceAdjustRecord;
exports.exportJdSkuList = exportJdSkuList;
exports.getJdCategoryList = getJdCategoryList;
exports.getJdCategoryOneList = getJdCategoryOneList;
exports.getJdCategoryPriceAdjustSummary = getJdCategoryPriceAdjustSummary;
exports.getJdCategoryThreeList = getJdCategoryThreeList;
exports.getJdCategoryTwoList = getJdCategoryTwoList;
exports.getJdGoodsDetail = getJdGoodsDetail;
exports.getJdGoodsPriceAdjustRecords = getJdGoodsPriceAdjustRecords;
exports.getJdMallSortOptions = getJdMallSortOptions;
exports.getJdPriceAdjustRecords = getJdPriceAdjustRecords;
exports.getJdSkuList = getJdSkuList;
exports.getSelfCategoryTree = getSelfCategoryTree;
exports.jdCategoryPriceAdjust = jdCategoryPriceAdjust;
exports.jdGoodsPriceAdjust = jdGoodsPriceAdjust;
exports.syncJdCategoryAll = syncJdCategoryAll;
exports.updateJdCategoryStatus = updateJdCategoryStatus;
exports.updateJdGoodsStatus = updateJdGoodsStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 京东SKU列表
 */
function getJdSkuList(params) {
  return (0, _request.default)({
    url: '/admin/jd/mall/goods/list',
    method: 'POST',
    data: params || {}
  });
}

/**
 * 导出商品列表
 */
function exportJdSkuList(params) {
  return (0, _request.default)({
    url: '/admin/jd/store/sku/export',
    method: 'GET',
    params: params
  });
}

/**
 * 京东商城分类列表（树形）
 * POST jd/mall/category/list
 * body: categoryId, groupLevel, groupName, parentId, status(1-启用,0-禁用)
 */
function getJdCategoryList(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 京东商城分类状态切换
 * POST jd/mall/category/status
 * body: categoryId, status(1-启用,0-禁用)
 */
function updateJdCategoryStatus(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/status',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 京东商城分类同步全部
 * POST jd/mall/category/syncAll，无参数
 */
function syncJdCategoryAll() {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/syncAll',
    method: 'POST'
  });
}

/**
 * 京东商城分类-一级下拉
 * POST jd/mall/category/one/list
 * body: keyword
 */
function getJdCategoryOneList(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/one/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 京东商城分类-二级下拉
 * POST jd/mall/category/two/list
 * body: keyword, categoryOneId
 */
function getJdCategoryTwoList(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/two/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 京东商城分类-三级下拉
 * POST jd/mall/category/three/list
 * body: keyword, categoryTwoId
 */
function getJdCategoryThreeList(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/three/list',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 京东SKU列表-排序选项
 * POST jd/mall/sort/options
 */
function getJdMallSortOptions() {
  return (0, _request.default)({
    url: '/admin/jd/mall/sort/options',
    method: 'POST'
  });
}

/**
 * 京东商品上下架
 * POST jd/mall/goods/updateStatus
 * body: listStatus, skuId
 */
function updateJdGoodsStatus(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/goods/updateStatus',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 京东商品详情
 * POST jd/mall/goods/detail，参数 skuId；返回即 data，无 code/message 包装
 */
function getJdGoodsDetail(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/goods/detail',
    method: 'POST',
    data: data || {}
  });
}

/**
 * 手动清除京东前台缓存
 * POST /admin/jd/mall/cache/clear
 */
function clearJdMallCache() {
  return (0, _request.default)({
    url: '/admin/jd/mall/cache/clear',
    method: 'POST'
  });
}

/**
 * 自营分类树（直接返回：id / name / child）
 * GET category/list/tree?status=-1&type=8
 */
function getSelfCategoryTree() {
  return (0, _request.default)({
    url: '/admin/category/list/tree?status=-1&type=8',
    method: 'GET'
  });
}

/**
 * 京东分类调价
 * POST /admin/jd/mall/category/price-adjust
 * body: categoryId, categoryName, adjustType, adjustRatio, remark
 * adjustType: margin-按毛利率，none-不调价；后端兼容历史ratio。
 */
function jdCategoryPriceAdjust(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/price-adjust',
    method: 'POST',
    data: data
  });
}

/** 分类下当前单独按毛利率调价的SKU数量，另返回全站尚未补分类的数量。 */
function getJdCategoryPriceAdjustSummary(params) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/price-adjust/summary',
    method: 'GET',
    params: params
  });
}

/**
 * 京东分类调价记录列表（分页）
 * POST /admin/jd/mall/category/price-adjust/records
 * body: categoryId, page, limit
 */
function getJdPriceAdjustRecords(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/category/price-adjust/records',
    method: 'POST',
    data: data
  });
}

/**
 * 删除京东分类调价记录
 * DELETE /admin/jd/mall/category/price-adjust/{id}
 */
function deleteJdPriceAdjustRecord(id) {
  return (0, _request.default)({
    url: "/admin/jd/mall/category/price-adjust/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 京东单商品调价
 * POST /admin/jd/mall/goods/price-adjust
 * body: skuId, skuName, categoryOne, adjustType, adjustRatio, remark
 */
function jdGoodsPriceAdjust(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/goods/price-adjust',
    method: 'POST',
    data: data
  });
}

/**
 * 京东单商品调价记录列表（分页）
 * POST /admin/jd/mall/goods/price-adjust/records
 * body: skuId, page, limit
 */
function getJdGoodsPriceAdjustRecords(data) {
  return (0, _request.default)({
    url: '/admin/jd/mall/goods/price-adjust/records',
    method: 'POST',
    data: data
  });
}